import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPortal } from "@/components/ui/dialog"

type StaleVersionNoticeProps = {
  open?: boolean
}

export const StaleVersionNotice = ({ open }: StaleVersionNoticeProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          variant="small"
          data-testid="stale-version-notice"
          onEscapeKeyDown={(event) => event.preventDefault()}
          onPointerDownOutside={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}>
          <DialogHeader>
            <div className="p-8 pb-2 text-xl font-medium">{t("reportIssue.staleVersion.title")}</div>
            <p className="text-md text-on-surface-subdued px-8 pb-4">{t("reportIssue.staleVersion.body")}</p>
          </DialogHeader>
          <DialogFooter className="flex border-t">
            <Button onClick={() => window.location.reload()}>{t("reportIssue.staleVersion.refresh")}</Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}
